var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.7 11.5c-.1.2-.4.3-.6.2-1.6-1-3.6-1.2-6-.7-.2.1-.4-.1-.4-.3-.1-.2.1-.4.3-.4 2.6-.6 4.9-.3 6.9.8.2.1.3.4.2.6-.1 0-.2.1-.4-.2zm.9-2c-.2.3-.5.4-.8.2-1.8-1.1-4.5-1.4-6.6-.8-.3.1-.5-.1-.6-.3-.1-.3.1-.5.3-.6 2.5-.7 5.5-.4 7.5.9.2.1.3.4.2.6zm.1-2.1c-2.1-1.2-5.6-1.3-7.6-.7-.3.1-.6-.1-.7-.4-.1-.3.1-.6.4-.7 2.3-.7 6.2-.5 8.6.8.3.2.4.5.2.8-.2.2-.6.3-.9.2z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.2918eb6aecd73b09fbf68c0746f3b9c1.svg";
export { ForwardRef as ReactComponent };